/**
* @module n2es6/n2mapModule/N2CustomLineStyle
*/
import RegularShape from 'ol/style/RegularShape'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
/**
 * @classdesc
 * Custom style for feature linestring.
 * @api
 */
class N2CustomLineStyle extends RegularShape {
	constructor(opt_options) {
		var options = $n2.extend({
			
		}, opt_options);
		
	}
	render_(){
		
	}
}
export default N2CustomLineStyle
